














/* eslint-disable camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Notification_IssueUpdatedViewObject } from '@/types/apiServerContract';

@Component
export default class NotificationTypeIssueUpdated extends Vue {
	@Prop({ required: true, type: Object }) notification!: Notification_IssueUpdatedViewObject;
}
